import React, { useEffect, useMemo, useState } from "react";
import CustomModal from "@/shared/components/ui/Modal/CustomModal";
import ModalHeader from "@/shared/components/ui/Modal/ModalHeader";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";
import CampaignMessageTemplates from "./CampaignMessageTemplates";
import usePreviewLeads from "./usePreviewLeads";
import {
  cleanMessageTemplates,
  validateMessageTemplates,
} from "@/features/campaigns/utils/stepContentMode";

const CampaignMessageTemplatesModal = ({
  isOpen,
  onClose,
  campaignId,
  value,
  onSave,
  isSaving,
  description,
  initialChannel,
}) => {
  const [draft, setDraft] = useState(value ?? {});
  useEffect(() => {
    if (isOpen) setDraft(value ?? {});
  }, [isOpen, value]);
  const { leads, sender } = usePreviewLeads(campaignId);
  const errors = useMemo(() => validateMessageTemplates(draft), [draft]);
  const hasErrors = Object.keys(errors).length > 0;
  const changed = JSON.stringify(cleanMessageTemplates(draft)) !== JSON.stringify(cleanMessageTemplates(value));

  return (
    <CustomModal isOpen={isOpen} onClose={onClose} className="rounded-lg p-5" width="1080px">
      <div className="flex flex-col gap-4 w-full">
        <ModalHeader title="Campaign messages" onClose={onClose} />
        {description && <p className="text-xs text-gray-600 dark:text-gray-300">{description}</p>}
        <CampaignMessageTemplates
          initialChannel={initialChannel}
          value={draft}
          onChange={setDraft}
          errors={errors}
          previewLeads={leads}
          sender={sender}
        />
        <div className="flex gap-2 justify-between w-full items-center">
          <SecondaryButton
            title="Cancel"
            textColor="dark"
            onClick={onClose}
            className="shadow-none border-none w-fit text-gray-300 hover:text-gray-800"
          />
          <PrimaryButton
            startContent={false}
            children={isSaving ? "Saving" : "Save messages"}
            onClick={() => onSave?.(cleanMessageTemplates(draft))}
            isLoading={isSaving}
            className="w-fit shadow-none"
            disabled={hasErrors || !changed}
          />
        </div>
      </div>
    </CustomModal>
  );
};

export default CampaignMessageTemplatesModal;
